/** @format */

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { useSelector, useDispatch } from 'react-redux';

import { selectVoucherSelectedCustomers } from '../../redux/voucher/voucher.selector';
import { setVoucherSelectedCustomers } from '../../redux/voucher/voucher.actions';

const Record = ({
  voucherId,
  voucherIssuanceId,
  createdAt,
  firstName,
  lastName,
  voucherAmount,
  voucherExpirationDate,
  voucherNumber,
}) => {
  const selectedCustomers = useSelector(selectVoucherSelectedCustomers);
  const [isSelected, setIsSelected] = useState(
    selectedCustomers.find((obj) => obj.voucherNumber === voucherNumber)
      ? true
      : false
  );

  useEffect(() => {
    setIsSelected(
      selectedCustomers.find((obj) => obj.voucherNumber === voucherNumber)
        ? true
        : false
    );
  }, [selectedCustomers, voucherNumber]);

  const dispatch = useDispatch();

  const handleClick = () => {
    if (isSelected) {
      dispatch(
        setVoucherSelectedCustomers(
          selectedCustomers.filter((obj) => obj.voucherNumber !== voucherNumber)
        )
      );
    } else {
      dispatch(
        setVoucherSelectedCustomers([
          ...selectedCustomers,
          {
            voucherId,
            voucherIssuanceId,
            createdAt,
            firstName,
            lastName,
            voucherAmount,
            voucherExpirationDate,
            voucherNumber,
          },
        ])
      );
    }
    setIsSelected((isSelected) => !isSelected);
  };

  return (
    <Box
      component={motion.div}
      whileTap={{ scale: 0.9 }}
      sx={{
        backgroundColor: selectedCustomers.find(
          (obj) => obj.voucherNumber === voucherNumber
        )
          ? '#d3ffd3'
          : 'white',
        display: 'grid',
        gridTemplateColumns: '1.1fr 1fr 1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: '1rem',
        padding: '1rem',
        borderRadius: '0.5rem',
        border: '1px solid black',
      }}
      onClick={handleClick}
    >
      <Typography sx={{ alignSelf: 'center' }}>{voucherId}</Typography>
      <Typography sx={{ alignSelf: 'center' }}>{voucherIssuanceId}</Typography>
      <Typography sx={{ alignSelf: 'center' }}>
        {dayjs(createdAt).format('MM-DD-YYYY')}
      </Typography>
      <Typography sx={{ alignSelf: 'center' }}>
        {firstName + ' ' + lastName}
      </Typography>

      <Typography sx={{ alignSelf: 'right' }}>{'$' + voucherAmount}</Typography>
      <Typography sx={{ alignSelf: 'center' }}>
        {dayjs(voucherExpirationDate).format('MM-DD-YYYY')}
      </Typography>
      <Typography sx={{ alignSelf: 'center' }}>{voucherNumber}</Typography>
    </Box>
  );
};

export default Record;
